module.exports = __webpack_public_path__ + "static/img/arinkel-1.b3c5cc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/arinkel-1.jpg
// module id = YvzO
// module chunks = 1